/**
 * DpCreateMetricsService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpCreateMetricsService {
    getMetricsData = (body) => {
        return apiClient.post("/dataProcessing/advancedRatios", body);
    }

    createMetric = (body) => {
        return apiClient.post("/advanceratio", body);
    }

    editMetric = (body) => {
        return apiClient.post("/editadvanceratio", body);
    }

    deleteMetric = (id) => {
        return apiClient.post("/deleteadvanceratio", { id });
    }

    getMeasureDropDownOptions = () => {
        return apiClient.get("/getAllMeasures");
    }

    getCategoryDropDownOptions = (body) => {
        return apiClient.post("/getCategoryByMeasure", body);
    }

    getMetricDropDownOptions = (body) => {
        return apiClient.post("/getMetricByCategory", body);
    }
}
